import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="integration--tippyjs"
export default class extends Controller {
  static values = {
    content: String,
    allowHtml: Boolean,
  };

  async connect() {
    const token = (this.connectToken = {});
    const { default: tippy } = await import("tippy.js");
    if (this.connectToken !== token) return;

    tippy(this.element, {
      content: this.contentValue,
      allowHTML: this.allowHtmlValue,
    });
  }

  disconnect() {
    this.connectToken = null;
  }
}
